import { Button } from '@/components/ui/button';
import { CheckCircle, Clock, DollarSign, Pencil } from 'lucide-react';
import { useNotify, useRecordContext, useRefresh, useUpdate } from 'ra-core';
import { Link } from 'react-router-dom';
import { useHasPermission } from '../rbac/useHasPermission';
import { VendorBill } from '../types';

export const VendorBillActions = () => {
    const record = useRecordContext<VendorBill>();
    const notify = useNotify();
    const refresh = useRefresh();
    const [update, { isPending }] = useUpdate();
    const { hasPermission: canManage } = useHasPermission('manage_procurement');

    if (!record) return null;

    const handleUpdateStatus = (newStatus: string) => {
        update('vendor_bills', 
               { id: record.id, data: { status: newStatus }, previousData: record }, 
               { 
                   onSuccess: () => {
                       notify(`Bill marked as ${newStatus}`, { type: 'success' });
                       refresh();
                   },
                   onError: () => {
                       notify(`Error updating bill status`, { type: 'error' });
                   }
               });
    };

    return (
        <div className="flex gap-2 items-center">
            <Button asChild size="sm" variant="outline">
                <Link to={`/vendor_bills/${record.id}`}>
                    <Pencil className="w-4 h-4 mr-2" />
                    Edit
                </Link>
            </Button>

            {record.status === 'draft' && (
                <Button 
                    size="sm" 
                    onClick={() => handleUpdateStatus('pending_approval')}
                    disabled={isPending}
                >
                    <Clock className="w-4 h-4 mr-2" />
                    Submit for Approval
                </Button>
            )}
            
            {record.status === 'pending_approval' && canManage && (
                <Button
                    size="sm"
                    className="bg-emerald-600 hover:bg-emerald-700 text-white"
                    onClick={() => handleUpdateStatus('approved')}
                    disabled={isPending}
                >
                    <CheckCircle className="w-4 h-4 mr-2" />
                    Approve Bill
                </Button>
            )}

            {record.status === 'approved' && canManage && (
                <Button
                    size="sm"
                    className="bg-blue-600 hover:bg-blue-700 text-white"
                    onClick={() => handleUpdateStatus('paid')}
                    disabled={isPending}
                >
                    <DollarSign className="w-4 h-4 mr-2" />
                    Mark as Paid
                </Button>
            )}
        </div>
    );
};
